module.exports = __webpack_public_path__ + "img/logo-mfu.40d64bbe.png";